import React, { Component } from 'react'

import ModalUploader from './modalUploader/modalUploader'

import { connect } from 'react-redux'
import * as messageActions from '../../../../actions/chat/messageActions'

import './modalWindowFooter.css'

class ModalWindowFooter extends Component {
  getLatestTime = () => {
    //find related chat and extract latest message timestamp:
    const chatsFiltered = this.props.chats
      .filter(el => {
        return el.contactId === this.props.contact.id
      })
    let latestTime = chatsFiltered.length === 0 ?
      0 : chatsFiltered[0].messages.length === 0 ?
        0 : chatsFiltered[0].messages[chatsFiltered[0].messages.length - 1].time;
    return latestTime
  }

  messageSendHandler = (e) => {
    if (e.key !== 'Enter') return;
    if (e.target.value.trim() === '') return;
    console.log('sending from client')



    //send message and put owner to members:
    this.props.messageOnSend({
      to: this.props.contact.id,
      seen: false,
      message: e.target.value.trim(),
      latestTime: this.getLatestTime()
    });

    e.target.value = '';
  }

  render() {
    let latestTime = this.getLatestTime()
    return (
      <div className="modalWindowFooter">
        <ModalUploader
          latestTime={latestTime}
          to={this.props.contact.id}
          owner={this.props.myId} />
        <input onKeyPress={this.messageSendHandler} type="text" placeholder="Type a message..." />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    contacts: state.user.allUsers,
    chats: state.messageReducer.chats,
    myId: state.auth.currentUser.id
  }
}

const mapDispatchToProps = {
  messageOnSend: messageActions.messageOnSend
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalWindowFooter);


// WEBPACK FOOTER //
// ./src/common/chat/modalWindow/modalWindowFooter/modalWindowFooter.js